import { Fragment, memo, useState } from 'react';
import PropTypes from 'prop-types';

import { HooksService } from 'basic-components';
import TimeService from 'dashboard-services/services/TimeService';

const RunTime = ({ startTime = undefined, endTime = undefined, isRunning = false }) => {
  const [time, setTime] = useState(() => TimeService.getIsoDurationBetween(startTime, endTime, isRunning))

  HooksService.useInterval(() => {
    if(isRunning) {
      setTime(TimeService.getIsoDurationBetween(startTime, endTime, isRunning))
    }
  }, 1000)

  return (
    <Fragment>
      {time}
    </Fragment>
  );
}

RunTime.propTypes = {
  endTime: PropTypes.string,
  isRunning: PropTypes.bool,
  startTime: PropTypes.string,
}

export default memo(RunTime);